import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Control + Beschriftung in einer Zeile (MUI-`FormControlLabel`-Ersatz). */
export const FormControlLabel = forwardRef(function FormControlLabel({ control, label, disabled, className, ...rest }, ref) {
    return (_jsxs("label", { ref: ref, className: cn('sec-form-control-label', disabled && 'sec-form-control-label--disabled', className), ...rest, children: [control, _jsx("span", { children: label })] }));
});
